import { useState } from "react";
import { Link } from "react-router-dom";

import { cuanto, fechaHora, kmTexto, quienes } from "../../shared/repuestosColocados";

/* «Repuestos colocados» de la ficha de la unidad: cada pieza que se le puso,
 * la más nueva arriba, de CantApp y de la ticketera.
 *
 * DE DÓNDE SALIÓ VA EN CADA FILA, como en «Qué le hicieron»: lo de CantApp es
 * una carga vieja sin ticket que la respalde, y lo de la ticketera abre su
 * ticket. Se muestran las primeras `primeras` y el resto con un botón: un
 * tractor viejo tiene cientos, y la ficha es para mirar, no para scrollear. */
export default function RepuestosDeUnidad({ filas = [], primeras = 15 }) {
  const [todas, setTodas] = useState(false);
  const visibles = todas ? filas : filas.slice(0, primeras);

  return (
    <>
      <ul className="pf-lista pf-historial pf-repuestos">
        {visibles.map((f) => (
          <li key={f.clave} data-origen={f.origen}>
            <span className={"pill " + (f.origen === "ticketera" ? "ojo" : "gris")}>
              {f.enlace ? <Link to={f.enlace}>{f.origenTexto} #{f.origen_id}</Link> : f.origenTexto}
            </span>
            <span>
              <b>{cuanto(f.cantidad, f.unidad)} × {f.descripcion}</b>
              {f.marca ? ` · ${f.marca}` : ""}
              {f.codigo ? ` · cód. ${f.codigo}` : ""}
            </span>
            <em className="tk-item-meta">
              {fechaHora(f.cuando) || "sin fecha"}
              {kmTexto(f.km) ? ` · ${kmTexto(f.km)}` : ""}
              {quienes(f) ? ` · ${quienes(f)}` : ""}
              {f.detalle ? ` · ${f.detalle}` : ""}
            </em>
          </li>
        ))}
      </ul>
      {filas.length > primeras && (
        <button type="button" className="link-button" onClick={() => setTodas(!todas)}>
          {todas ? "Ver menos" : `Ver los ${filas.length}`}
        </button>
      )}
    </>
  );
}
